import { Fragment, useContext, useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Box } from '@mui/material';
import { FlightStatusContext } from 'context';
import {
  FormWrapper,
  Loader,
  ResultsWrapper,
  MapTiler,
  DetailsModal,
} from 'components';
import { getPlanesPosition, getFlights } from 'api/flights';
import { useMemo } from 'react';

const imageStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  height: '100%',
};

const FlightStatus = () => {
  const { t } = useTranslation();
  const {
    state: {
      get_flights_list_status,
      get_flight_position_status,
      date,
      modal,
      // get_countries_status
    },
    dispatch,
  } = useContext(FlightStatusContext);
  const [isSearch, setIsSearch] = useState({
    arrival: false,
    departure: false,
    number: false,
  });
  // const [planesPositions, setPlanesPositions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [flightDetailLoading, setFlightDetailLoading] = useState(false);

  // Get searched list
  const getFlightsList = useCallback(
    async (flightNumber) => {
      if (flightNumber && date?.value) {
        setFlightDetailLoading(true);
        // dispatch({ type: 'GET_FLIGHTS_LIST_LOADING' });
        try {
          const fetched_flights = await getFlights({
            flightNumber,
            date: date.value,
          });
          // dispatch({
          //   type: 'GET_FLIGHTS_LIST_SUCCESS',
          //   payload: fetched_flights,
          // });
          dispatch({
            type: 'HANDLE_CHANGE_STATE',
            payload: {
              flights: fetched_flights,
            },
          });
          dispatch({
            type: 'HANDLE_MODAL',
            payload: {
              open: true,
              id: fetched_flights?.flightStatuses[0]?.flightId,
            },
          });
          setFlightDetailLoading(false);
          // dispatch({ type: 'GET_FLIGHTS_LIST_ERROR' });
        } catch (err) {
          setFlightDetailLoading(false);
          // dispatch({ type: 'GET_FLIGHTS_LIST_ERROR' });
        }
      }
    },
    [dispatch, date]
  );

  useEffect(() => {
    document.getElementById('cms-header').innerHTML =
      localStorage.getItem('header');
    document.getElementById('cms-footer').innerHTML =
      localStorage.getItem('footer');

    document.body.style.maxWidth = 'auto';
    document.body.style.width = '100%';
  }, []);

  // const getPositions = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     const response = await getPlanesPosition();
  //     if (response?.length > 0)
  //       setPlanesPositions(
  //         response?.filter(
  //           (flight) =>
  //             flight?.position?.latitude && flight?.position?.longitude
  //         )
  //       );
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error(error);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (!Object.values(isSearch).includes(true) && !get_flights_list_status)
  //     getPositions();
  // }, [isSearch, get_flights_list_status, getPositions]);

  return (
    <Fragment>
      <Loader
        open={
          [/* get_countries_status,  */ get_flights_list_status].includes(
            'loading'
          ) /* ||
          loading ||
          flightDetailLoading */
        }
      />
      <Grid container position="relative" minHeight="537px">
        <Box
          component="img"
          src={process.env.PUBLIC_URL + '/background_desktop.png'}
          alt="background"
          loading="lazy"
          sx={{
            ...imageStyle,
            display: {
              sm: 'initial',
              xs: 'none',
            },
          }}
        />
        <Box
          component="img"
          src={process.env.PUBLIC_URL + '/background_mobile.png'}
          alt="background"
          loading="lazy"
          sx={{
            ...imageStyle,
            display: {
              sm: 'none',
              xs: 'initial',
            },
          }}
        />
        <Grid
          container
          flexDirection="column"
          alignItems="center"
          position="relative"
          zIndex={1}
          sx={{ p: { sm: '60px 20px', xs: '30px 10px' } }}
        >
          <Typography
            variant="h1"
            component="h1"
            color="primary"
            textAlign="center"
            mb="10px"
          >
            {t('flightstatus.search.h1')}
          </Typography>
          <Typography variant="p" textAlign="left" mb="30px" maxWidth="700px">
            {t('flightstatus.search.subtitle')}
           {/*  <ul>
              <li>
                {t('flightstatus.search.rebook')}{' '}
                <a href={t('flightstatus.search.link.mmb')} target="_blank">
                  {t('flightstatus.search.mybooking.link.description')}
                </a>
                
                {t('flightstatus.search.rebook_2')}
              </li>
              <li>
                {t('flightstatus.search.cancelled')}{' '}
                <a href={t('flightstatus.search.cancel.link')} target="_blank">
                  {t('flightstatus.search.cancel.link.description')}
                </a>
              </li>
              <li>{t('flightstatus.search.agentbooking')}</li>
        </ul> */}
          </Typography>

          <FormWrapper setIsSearch={setIsSearch} isSearch={isSearch} />
        </Grid>
      </Grid>
      {/* {!get_flights_list_status && !loading && planesPositions?.length > 0 && (
        <Grid
          container
          maxWidth="1152px"
          p="40px 20px 20px"
          m="auto"
          flexDirection="column"
        >
          <Typography variant="h5" color="primary">
            Live sas flights
          </Typography>
          {!modal?.id &&
            !get_flight_position_status &&
            !get_flights_list_status && (
              <MapTiler
                mode="default"
                flightData={null}
                originAirport={{}}
                destinationAirport={{}}
                flights={planesPositions}
                showFlightDetails={getFlightsList}
              />
            )}
        </Grid>
      )} */}
      {get_flights_list_status && get_flights_list_status !== 'loading' && (
        <Grid container id="flight-results">
          <ResultsWrapper isSearch={isSearch} />
        </Grid>
      )}
      <DetailsModal />
    </Fragment>
  );
};

export default FlightStatus;
